import { useEffect, useState } from "react";
import "../../pages/navbar.css";
import "../styles.css";
import { useNavigate } from "react-router-dom";
import useEnrollmentStore, { ProtectionPlanName } from "../../store/EnrollmentStore";
import { Button, Card, CardActions, CardContent, CardMedia, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { paths } from "../../paths";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { EConsentModal } from "../../Common/EConsentModal";
import useProfileStore from "../../store/ProfileStore";
import Footer from "../footer";

export function TaxPreparationServiceEnrollV2() {
  const navigate = useNavigate();
  const { protectionPlanEnrollment, taxPrepEnrollment } = useEnrollmentStore();
  const { eConsent } = useProfileStore();
  const [showConsentModal, setShowContentModal] = useState(false);

  useEffect(() => {
    if (process.env.REACT_APP_TAX_PREPNETWORK_ALLOWED === 'false' ||
      protectionPlanEnrollment?.subscriptionPlan === ProtectionPlanName.Premium ||
      protectionPlanEnrollment?.subscriptionPlan === ProtectionPlanName?.Professional) {
      navigate(paths.dashboard.taxShield.reports)
    }
  }, []);



  const onClickHandler = () => {
    console.log(eConsent);
    if (eConsent) {
      navigate('/tax-preparation-service-enroll');
    } else {
      setShowContentModal(true);
    }
  }

  const onAgreeHandler = () => {
    setShowContentModal(false);
    navigate('/tax-preparation-service-enroll');
  }

  const onConsentModalCloseHandler = () => {
    setShowContentModal(false);
  }

  return (
    <>
      <Card sx={{ width: '100%', height: '90vh', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <CardMedia component="img" src="/assets/tax-prep-bg.png" sx={{ position: 'absolute', top: 0, right: 0 }} />
        <CardContent sx={{ position: 'absolute', backgroundColor: 'transparent', top: 50, left: 5 }}>
          <h1 className="headerTitle">Have your taxes filed <br />professionally.</h1>
          <Typography variant="body2" sx={{ mt: 3, fontSize: '12px' }}>Get professional tax preparation services by the most<br />trusted brand in Tax. Our network of licensed professionals<br />are here to get your returns done quickly and accurately.</Typography>
          <CardActions sx={{ padding: 0 }}>
            <Button className="plan-fill-button mt-3" onClick={onClickHandler}>Get Started <ArrowForward /> </Button>
          </CardActions>
        </CardContent>
      </Card>
      {showConsentModal && <EConsentModal onAgree={onAgreeHandler} onClose={onConsentModalCloseHandler} open={showConsentModal} />}
      <Footer />
    </>
  );
}

export function TaxPreparationServiceEnroll() {
  const navigate = useNavigate();
  const { protectionPlanEnrollment, taxPrepEnrollment } = useEnrollmentStore();

  useEffect(() => {
    if (process.env.REACT_APP_TAX_PREPNETWORK_ALLOWED === 'false' ||
      protectionPlanEnrollment?.subscriptionPlan === ProtectionPlanName.Premium ||
      protectionPlanEnrollment?.subscriptionPlan === ProtectionPlanName?.Professional) {
      navigate("/dashboard")
    }
  }, []);

  return (
    <>
      <Container className="mt-3 mb-5">
        <Row className="justify-content-center">
          <Col md={10} className="d-flex tax-preparation-service-intro-bg py-5 px-lg-3">
            <Row className="px-lg-5 mt-5 pt-5">
              <Col lg={6}>
                <h1 className="content-box-heading mb-3 mt-0" style={{ color: 'white' }}>
                  Get Your Taxes Done Today
                </h1>

                <p className="content-text mb-5" style={{ color: 'white' }}>
                  Get professional tax preparation services at the most trusted brand in Tax. Our network of licensed professionals are here to get your returns done quickly and accurately.
                </p>
                <div className="d-flex justify-content-between mt-5 pt-5 align-items-center">
                  <a className="letsdolater-taxprep mt-5" onClick={() => navigate("/dashboard")} style={{ color: 'white' }}>Let's do this later...</a>
                  <button className="btn-continue mt-5" style={{ width: '50%', fontWeight: 'bold' }} onClick={() => navigate('/tax-preparation-service-enroll')}>Get Started</button>
                </div>
              </Col>

            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}
